export default __webpack_public_path__ + "static/mockCalendar2-3ec4d2299a8919e5361e17aa43cf134b.png";